// extracted by mini-css-extract-plugin
export default {"no-data-cloud-summary":"prerequisites_no-data-cloud-summary__YOEkr"};